import React from 'react';
import { useAuth } from './context/AuthContext';
import { Link } from 'react-router-dom';

function Dashboard() {
    const { user } = useAuth();

    if (!user) {
        return <p>Cargando...</p>;
    }

    return (
        <div className="container mt-5">
            <div className="card shadow">
                <div className="card-body">
                    <h1 className="card-title">¡Bienvenido, {user.nombre}!</h1>
                    <p className="card-text">Has iniciado sesión correctamente.</p>
                    
                    <h4 className="mt-4">Sistemas a los que tienes acceso:</h4>
                    {user.accesos && user.accesos.length > 0 ? (
                        <ul className="list-group">
                            {user.accesos.map((acceso) => (
                                <li key={acceso.sistema_id} className="list-group-item d-flex justify-content-between align-items-center">
                                    <Link to={`/sistemas/${acceso.sistema_id}`}>{acceso.sistema_nombre}</Link>
                                    <span className="badge bg-primary rounded-pill">{acceso.rol}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-muted">No tienes sistemas asignados.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Dashboard;